export default "__VITE_ASSET__adf4b8c0__"